import React from 'react';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import { FaHome, FaTasks, FaBuilding, FaArrowLeft } from 'react-icons/fa';
import { useI18n } from '../../i18n';
import './NotFound.css';

const NotFound = (props) => {
    const { t } = useI18n();
    return (
    <div className="NotFound">
        <div className="not-found-card">
            <h1 className="not-found-code">404</h1>
            <h2 className="not-found-title">{props.message || t('notFound.title')}</h2>
            <p className="not-found-hint">
                {t('notFound.hint')}
            </p>
            <div className="not-found-actions">
                <Button as={Link} to="/" variant="primary" className="not-found-btn">
                    <FaHome /> {t('nav.dashboard')}
                </Button>
                <Button as={Link} to="/tasks" variant="outline-primary" className="not-found-btn">
                    <FaTasks /> {t('nav.tasks')}
                </Button>
                <Button as={Link} to="/assets" variant="outline-primary" className="not-found-btn">
                    <FaBuilding /> {t('nav.assets')}
                </Button>
                <Button variant="light" className="not-found-btn" onClick={() => props.history.goBack()}>
                    <FaArrowLeft /> {t('notFound.goBack')}
                </Button>
            </div>
        </div>
    </div>
    );
};

export default NotFound;
